export default __webpack_public_path__ + "static/media/passLogo.f6e8a564.svg";